// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckoutOrderCardCarousel_container__3rxv_","carousel":"CheckoutOrderCardCarousel_carousel__EoYcj","loaderContainer":"CheckoutOrderCardCarousel_loaderContainer__7GDhn"};